import { useEffect } from "react"

import { installNewTabClickGuard } from "@/lib/new-tab-click"

export function NewTabClickGuard() {
  useEffect(() => installNewTabClickGuard(window), [])
  return null
}
